<template>
  <div class="text-center">
    <div id="steps">
      <b-button
        type="button"
        id="steponebtn"
        v-bind:disabled="is1disabled"
        :variant="variant1"
        class="mt-4 rounded-pill"
        @click.prevent="setStep(1)"
      >
        <span>1</span>
      </b-button>
      <hr />
      <b-button
        type="button"
        id="steptwobtn"
        v-bind:disabled="is2disabled"
        :variant="variant2"
        class="mt-4 rounded-pill"
        @click.prevent="setStep(2)"
      >
        <span>2</span>
      </b-button>
      <hr />
      <b-button
        type="button"
        id="stepthreebtn"
        v-bind:disabled="is3disabled"
        :variant="variant3"
        class="mt-4 rounded-pill"
        @click.prevent="setStep(3)"
      >
        <span>3</span>
      </b-button>
      <hr />
      <b-button
        type="button"
        id="stepfourbtn"
        v-bind:disabled="is4disabled"
        :variant="variant4"
        class="mt-4 rounded-pill"
        @click.prevent="setStep(4)"
      >
        <span>4</span>
      </b-button>
      <hr />
      <b-button
        type="button"
        id="stepfivebtn"
        v-bind:disabled="is5disabled"
        :variant="variant5"
        class="mt-4 rounded-pill"
      >
        <span>5</span>
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "StepNav",
  data: function() {
    return {};
  },
  computed: {
    step: {
      get() {
        return this.$store.state.step;
      },
      set(value) {
        this.$store.commit("changeStep", value);
      },
    },
    nextStep: {
      // stepSeven gets this value and uses it to
      // change the step state on delete confirmation
      set(value) {
        this.$store.commit("setNextStep", value);
      },
    },
    is1disabled: {
      get() {
        return this.amIDisabled(1);
      },
    },
    is2disabled: {
      get() {
        return this.amIDisabled(2);
      },
    },
    is3disabled: {
      get() {
        return this.amIDisabled(3);
      },
    },
    is4disabled: {
      get() {
        return this.amIDisabled(4);
      },
    },
    is5disabled: {
      get() {
        return this.amIDisabled(5);
      },
    },
    variant1: {
      get() {
        return this.whichVariant(1);
      },
    },
    variant2: {
      get() {
        return this.whichVariant(2);
      },
    },
    variant3: {
      get() {
        return this.whichVariant(3);
      },
    },
    variant4: {
      get() {
        return this.whichVariant(4);
      },
    },
    variant5: {
      get() {
        return this.whichVariant(5);
      },
    },
  },
  methods: {
    setStep: function(newStep) {
      if (newStep < 5 && this.step == 7) {
        this.$bvModal.show("confirm-delete-7");
        this.nextStep = newStep;
      } else {
        this.step = newStep;
      }
    },
    confirmDelete(newStep) {
      console.log(newStep);
    },

    amIDisabled: function(num) {
      let step = this.$store.state.step;
      // special case for step 7
      if (num < 5 && step == 7) {
        return false;
      }

      // disable 1-4 on steps 5 & 6
      if (step === 5 || step === 6) {
        if (num < 5) {
          return true;
        }
      }

      if (
        num == step ||
        (step > 3 && num > 3) ||
        step > 4 ||
        (num == 5 && step > 5)
      ) {
        return true;
      }
      return false;
    },
    whichVariant: function(num) {
      let step = this.$store.state.step;
      if (step === 5 || step === 6) {
        if (num < 5) {
          return "secondary";
        }
      }
      if (num === 5) {
        if (step < 6) {
          return "secondary";
        }
        return "primary";
      }
      if (num === 4) {
        if (step > 3 && step < 6) {
          return "primary";
        }
      }
      if (step === num) {
        return "primary";
      }
      return "outline-primary";
    },
  },
};
</script>
